import { Client } from "domain/entities/client";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ClientState {
  client: Client | null;
  setClient: (newClient: Partial<Client>) => void;
  resetClient: () => void;
}

const initialClientState: Client = {
  id: "",
  name: "",
  city: "",
  type: "",
  createdAt: new Date(),
  modifiedAt: new Date(),
};

export const useClientSelectedStore = create<ClientState>()(
  devtools(
    (set) => ({
      project: initialClientState,
      setClient: (newClient) =>
        set((state) => ({
          client: { ...state.client, ...newClient } as Client,
        })),
      resetClient: () => set({ client: initialClientState }),
    }),
    { name: "ClientSelected" }
  )
);
